import styled from '@emotion/styled';

export const CalendarBookingContainer = styled.div`
  width: 100%;

  .rbc-row {
    height: auto;

    .rbc-row-segment {
      .rbc-event {
        height: 100%;

        &.rbc-event-continues-after {
        }

        &.rbc-event-continues-prior {
        }

        .rbc-event-content {
          height: 100%;
          line-height: 19px;
        }
      }
    }
  }

  .rbc-month-row {
    flex: unset;

    .rbc-row-content {
      height: 120px;
    }
  }

  .rbc-toolbar {
    .rbc-btn-group {
      button {
        border-color: var(--chakra-colors-blue-500);
        color: var(--chakra-colors-blue-500);
        font-weight: var(--chakra-fontWeights-semibold);
        height: var(--chakra-sizes-10);

        &:hover {
          background-color: var(--chakra-colors-blue-50);
        }
      }
    }
  }

  .rbc-agenda-view {
    &::-webkit-scrollbar {
      height: 7px;
    }

    &::-webkit-scrollbar-track {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 24px;
      height: 50px;
    }
  }
`;
